module.exports = __webpack_public_path__ + "static/images/pass-card-null.cfe0409.png";